// extracted by mini-css-extract-plugin
module.exports = {"container":"Contact_container__3LKin","title":"Contact_title__z-qXk"};